import { useEffect } from 'react';

import { createCountStore } from '@stores/create-count-store';

const escapeLayerStore = createCountStore();

/**
 * Claims Escape for a floating UI that is neither a modal nor an overlay (the
 * two the Sidebar already stands down for). `useKeyPress` binds a bare
 * `document` listener, so otherwise every mounted handler fires on one keypress.
 */
export const useEscapeLayer = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return;
    escapeLayerStore.increase();
    return () => escapeLayerStore.decrease();
  }, [enabled]);
};

/** True while a floating layer has claimed Escape. See `useEscapeLayer`. */
export const useIsEscapeLayerActive = () => escapeLayerStore.useStore((s) => s.count > 0);
